import { runDemo } from "../shared/demoRunner";
import { createPbrRoughScene } from "./scene";

runDemo({ createScene: createPbrRoughScene });
